exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-0982e9c6]{\r\n    color: #333333;\r\n    text-decoration: none;\r\n    background-color: transparent;\n}\n@media only screen and (max-width:767px){\n.col[data-v-0982e9c6] {\r\n        flex-basis: auto;\r\n        flex-grow: initial;\r\n        min-width: auto;\r\n        max-width: -webkit-max-content;\r\n        max-width: -moz-max-content;\r\n        max-width: max-content;\r\n        position: relative;\r\n        width: 50%;\n}\n}\r\n\r\n", ""]);

// exports
